import styles from './instrumentV2.module.scss';

/**
 * A titled section of a form. Every group of fields gets a heading and one
 * line saying what it is for, so long screens stay scannable.
 *
 * Children are placed on a 12-column grid — use the span helpers from
 * `spans` rather than per-field widths.
 */
export const FormCard = ({title, description, children}) => (
  <section className={styles.card}>
    {(title || description) && (
      <header className={styles.cardHead}>
        {title && <h3>{title}</h3>}
        {description && <p>{description}</p>}
      </header>
    )}
    <div className={styles.cardBody}>{children}</div>
  </section>
);

/** Column spans for fields inside a FormCard. */
export const spans = {
  full: styles.full,
  half: styles.half,
  third: styles.third,
  twoThirds: styles.twoThirds,
};

/** Small helper text rendered under a field. */
export const Hint = ({children}) => (
  <span className={styles.hint}>{children}</span>
);

/**
 * Marks a value the API computes for us — greyed, dashed and tagged, so it
 * can never be mistaken for an input. See §4 of the instrument handover.
 */
export const derivedClass = styles.derived;

export const DerivedTag = () => (
  <span className={styles.tagDerived}>derived</span>
);

export default FormCard;
